import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravellerrentalpune() {

const cardData = {
keyword: "Tempo Traveller Rental Pune",
headingDescription: "Ruturaj Enterprises offers comfortable and dependable Tempo Traveller Rental Pune services for families, corporate groups, wedding functions, school outings, picnics, airport transfers, sightseeing plans, and long-distance journeys. Our Tempo Travellers are suitable for group transportation where passengers need convenient seating, practical luggage space, comfortable interiors, and a coordinated travel experience. From short one-day journeys to extended tours from Pune to popular destinations across Maharashtra and neighboring states, travelers can select suitable vehicles according to group size, trip duration, comfort requirements, and budget. Flexible rental arrangements make it easier to organize complete group transportation without depending on multiple cars or separate travel plans.",
topPlaces: [
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a popular hill destination for family holidays, college groups, corporate outings, and weekend tours from Pune. A Tempo Traveller makes the journey more convenient for groups by keeping everyone together while providing comfortable seating and enough room for travel luggage during the complete trip."
},
{
title: "Goa",
description: "Goa is a preferred long-distance destination for friends, families, corporate teams, and groups planning extended holidays from Pune. Traveling together in a Tempo Traveller creates a practical option for managing passengers, luggage, sightseeing schedules, and multiple stops while enjoying a coordinated road journey."
},
{
title: "Shirdi",
description: "Shirdi attracts families, senior travelers, religious groups, and organized tour parties throughout the year, making it suitable for group travel from Pune. A spacious Tempo Traveller allows passengers to remain together throughout the journey and offers a convenient arrangement for carrying personal belongings during the visit."
},
{
title: "Alibaug",
description: "Alibaug provides a convenient coastal getaway for families, friends, office groups, and weekend travelers looking for a trip from Pune. Group transportation by Tempo Traveller helps simplify the journey by providing shared seating, organized pickup arrangements, and sufficient luggage capacity for a relaxed travel experience."
},
{
title: "Nashik",
description: "Nashik is well suited for family tours, pilgrimage journeys, corporate travel, and group excursions from Pune because it combines sightseeing, cultural attractions, and nearby destinations. A Tempo Traveller offers a comfortable way for groups to travel together while maintaining a common schedule throughout the trip."
},
{
title: "Kolhapur",
description: "Kolhapur is a popular destination for family visits, temple tours, cultural trips, and group excursions from Pune. Hiring a Tempo Traveller provides passengers with a shared travel arrangement that can accommodate the group comfortably while allowing convenient planning for meals, sightseeing stops, and return travel."
},
{
title: "Bhandardara",
description: "Bhandardara is an attractive choice for nature trips, weekend outings, trekking groups, and family vacations from Pune. A Tempo Traveller is useful for these journeys because groups can travel together with their bags and outdoor equipment while enjoying a comfortable road-trip arrangement."
},
{
title: "Ganpatipule",
description: "Ganpatipule is a scenic coastal destination suitable for family holidays, temple visits, and organized group tours from Pune. Choosing a Tempo Traveller helps keep the entire group together during the longer journey and provides a practical combination of comfortable seating, luggage space, and flexible travel planning."
},
{
title: "Panchgani",
description: "Panchgani is a scenic hill station that works well for school excursions, family vacations, corporate outings, and short group trips from Pune. A Tempo Traveller gives groups a convenient shared vehicle for reaching the destination together while making it easier to coordinate sightseeing and scheduled return travel."
},
{
title: "Malshej Ghat",
description: "Malshej Ghat is a popular choice for nature lovers, photography groups, families, and weekend travelers looking for a scenic journey from Pune. Tempo Traveller rentals make group transportation easier by providing shared seating and enough space for personal luggage, helping passengers enjoy the road trip without coordinating several separate vehicles."
}
],
services: [
{
name: "Tempo Traveller On Rent Pune",
description: "Tempo Traveller On Rent Pune is designed for families, friends, office teams, and other groups that need a single comfortable vehicle for their journey. Ruturaj Enterprises provides practical rental arrangements with suitable seating, luggage space, and trip planning support for short-distance travel, weekend journeys, sightseeing programs, and longer road trips."
},
{
name: "Tempo Traveller Hire Pune",
description: "Tempo Traveller Hire Pune offers a convenient group transportation solution when traveling together is more practical than using several cars. The service can be arranged for family holidays, social gatherings, corporate movements, educational trips, and recreational tours with vehicle options selected according to passenger requirements."
},
{
name: "Tempo Traveller Booking Pune",
description: "Tempo Traveller Booking Pune makes it easier to reserve group transportation according to the planned travel schedule, destination, passenger count, and journey duration. Advance coordination can help organize pickup points, departure timings, vehicle requirements, luggage needs, and return arrangements for a smoother overall travel experience."
},
{
name: "AC Tempo Traveller Rental Pune",
description: "AC Tempo Traveller Rental Pune is suitable for travelers who prefer a cooler and more comfortable cabin during city travel as well as longer highway journeys. Air-conditioned group transportation is especially useful for family vacations, corporate travel, weddings, tourist tours, and summer trips where passengers may spend several hours on the road."
},
{
name: "Non AC Tempo Traveller Rental Pune",
description: "Non AC Tempo Traveller Rental Pune provides a practical group travel option for customers looking for a straightforward and economical vehicle arrangement. It can be considered for suitable weather conditions, short journeys, school programs, picnic plans, local travel, and budget-conscious group transportation requirements."
},
{
name: "Luxury Tempo Traveller Rental Pune",
description: "Luxury Tempo Traveller Rental Pune is intended for groups that want additional comfort and a more refined travel environment during their journey. These vehicles can be suitable for premium family tours, corporate programs, weddings, special occasions, and extended road trips where passenger comfort remains an important part of the travel plan."
},
{
name: "Tempo Traveller for Outstation Pune",
description: "Tempo Traveller for Outstation Pune provides a practical way for groups to travel from Pune to destinations across Maharashtra and nearby states without splitting passengers among multiple cars. The rental arrangement can support longer journeys with coordinated pickup, spacious seating, luggage accommodation, and a planned route suitable for the group."
},
{
name: "Tempo Traveller for Family Trip Pune",
description: "Tempo Traveller for Family Trip Pune is suitable for families traveling together for holidays, religious visits, weekend breaks, and multi-day tours. Keeping everyone in one vehicle makes coordination easier while providing shared seating and convenient luggage space for children, adults, and senior family members."
},
{
name: "Tempo Traveller for Group Travel Pune",
description: "Tempo Traveller for Group Travel Pune helps friends, relatives, social groups, and organized travel parties stay together throughout their journey. Instead of arranging several individual cars, groups can use a shared vehicle that simplifies communication, pickup planning, luggage management, sightseeing schedules, and overall trip coordination."
},
{
name: "Tempo Traveller for Corporate Events Pune",
description: "Tempo Traveller for Corporate Events Pune supports employee transportation for conferences, meetings, training programs, team outings, business events, and corporate gatherings. A dedicated group vehicle can make passenger movement easier by maintaining coordinated pickup and drop timings while allowing colleagues to travel together between planned locations."
},
{
name: "Tempo Traveller for Wedding Pune",
description: "Tempo Traveller for Wedding Pune is useful for transporting relatives, guests, friends, and wedding groups between homes, hotels, venues, and nearby destinations. Group vehicle arrangements can reduce the need for multiple cars and help wedding organizers maintain coordinated movement according to ceremonies and event schedules."
},
{
name: "Tempo Traveller for Airport Pickup Pune",
description: "Tempo Traveller for Airport Pickup Pune provides a convenient group transportation arrangement for passengers arriving together at Pune Airport or traveling as a group for an onward journey. The service can accommodate multiple travelers and luggage while supporting planned pickup timing and direct transfer to hotels, homes, offices, or other destinations."
},
{
name: "Affordable Tempo Traveller Rental Pune",
description: "Affordable Tempo Traveller Rental Pune focuses on providing practical group transportation for customers who want to manage travel expenses without arranging multiple separate vehicles. Rental planning can be aligned with passenger count, destination, journey duration, and vehicle requirements to create a suitable transportation arrangement for the planned trip."
},
{
name: "Tempo Traveller Rental Service Pune",
description: "Tempo Traveller Rental Service Pune offers group vehicle arrangements for one-day journeys, multi-day tours, family programs, business travel, weddings, school outings, and recreational trips. Ruturaj Enterprises can help coordinate the vehicle around the itinerary so passengers have a more organized travel experience from pickup through the scheduled return."
},
{
name: "Tempo Traveller for Picnic Pune",
description: "Tempo Traveller for Picnic Pune is a convenient option for families, friends, colleges, offices, and social groups planning recreational outings together. The vehicle provides shared transportation for passengers and their belongings, making it easier to coordinate departure times, destination stops, meals, activities, and return travel."
},
{
name: "Tempo Traveller for Local Sightseeing Pune",
description: "Tempo Traveller for Local Sightseeing Pune can be arranged for groups visiting multiple attractions during a planned sightseeing schedule around Pune and nearby travel circuits. Having one group vehicle makes it easier to coordinate stops, keep passengers together, manage luggage, and follow a customized itinerary without depending on separate cars."
},
{
name: "Tempo Traveller for One Day Trip Pune",
description: "Tempo Traveller for One Day Trip Pune is suitable for groups planning a same-day excursion to nearby destinations and attractions. The rental can be coordinated around the group's preferred departure and return schedule, providing a shared vehicle for comfortable travel, sightseeing stops, meals, and the complete round trip."
},
{
name: "Tempo Traveller for Corporate Travel Pune",
description: "Tempo Traveller for Corporate Travel Pune provides organized transportation for employees, management teams, clients, and business groups traveling between offices, hotels, meeting venues, industrial locations, and event destinations. A dedicated vehicle helps maintain coordinated movement and can be planned around the business itinerary and required pickup points."
},
{
name: "Tempo Traveller for Marriage Pune",
description: "Tempo Traveller for Marriage Pune helps families coordinate transportation for marriage ceremonies, receptions, pre-wedding functions, and related travel requirements. It can be useful for moving groups between residences, hotels, venues, and outstation locations while keeping relatives and guests together under one planned transportation arrangement."
},
{
name: "Tempo Traveller for Tourist Trip Pune",
description: "Tempo Traveller for Tourist Trip Pune is designed for groups exploring hill stations, beaches, pilgrimage destinations, heritage locations, and other tourist circuits from Pune. Shared transportation allows the group to follow a common itinerary while benefiting from convenient seating, luggage accommodation, and coordinated travel between different sightseeing locations."
},
{
name: "Tempo Traveller for School Trip Pune",
description: "Tempo Traveller for School Trip Pune supports educational tours, recreational excursions, field visits, and student group travel where organized transportation is required. The rental can be planned around the school itinerary, passenger requirements, pickup points, destination schedule, and return timing to help teachers and organizers manage group movement efficiently."
},
{
name: "Tempo Traveller for Outstation Tour Pune",
description: "Tempo Traveller for Outstation Tour Pune is suitable for multi-day group tours from Pune to destinations across Maharashtra, Goa, Karnataka, Gujarat, and other nearby travel circuits. A dedicated vehicle keeps the group together throughout the journey while allowing the itinerary to include sightseeing stops, overnight stays, meals, and planned return travel."
}
],
tableData: [
["Tempo Traveller On Rent Pune", "Convenient group vehicle rental for family tours, social trips, and organized journeys."],
["Tempo Traveller Hire Pune", "Flexible Tempo Traveller hiring for groups requiring shared and comfortable transportation."],
["Tempo Traveller Booking Pune", "Advance booking support for planned routes, passenger groups, and complete travel schedules."],
["AC Tempo Traveller Rental Pune", "Air-conditioned group travel option for comfortable journeys in different weather conditions."],
["Non AC Tempo Traveller Rental Pune", "Economical group transportation option for suitable short and long-distance travel requirements."],
["Luxury Tempo Traveller Rental Pune", "Premium travel arrangement for groups seeking enhanced comfort during tours and special events."],
["Tempo Traveller for Outstation Pune", "Dedicated group transportation for destinations outside Pune and longer road journeys."],
["Tempo Traveller for Family Trip Pune", "Shared vehicle solution for families traveling together with passengers and luggage."],
["Tempo Traveller for Group Travel Pune", "Convenient transportation for friends, relatives, social groups, and organized travel parties."],
["Tempo Traveller for Corporate Events Pune", "Coordinated transportation for meetings, conferences, employee events, and business programs."],
["Tempo Traveller for Wedding Pune", "Group vehicle arrangement for wedding guests, relatives, functions, and venue transfers."],
["Tempo Traveller for Airport Pickup Pune", "Planned group pickup and transfer service with space for passengers and travel luggage."],
["Affordable Tempo Traveller Rental Pune", "Budget-conscious group transportation planned around trip requirements and vehicle needs."],
["Tempo Traveller Rental Service Pune", "Complete rental support for family tours, corporate programs, sightseeing, and special events."],
["Tempo Traveller for Picnic Pune", "Comfortable shared transportation for recreational outings and organized picnic groups."],
["Tempo Traveller for Local Sightseeing Pune", "Group vehicle support for visiting multiple attractions within a planned sightseeing itinerary."],
["Tempo Traveller for One Day Trip Pune", "Same-day group travel option with coordinated departure, sightseeing, and return schedules."],
["Tempo Traveller for Corporate Travel Pune", "Dedicated transportation for employees, clients, business teams, and corporate itineraries."],
["Tempo Traveller for Marriage Pune", "Organized group travel for marriage ceremonies, receptions, relatives, and guest movements."],
["Tempo Traveller for Tourist Trip Pune", "Shared transportation for sightseeing tours covering popular tourist destinations and circuits."],
["Tempo Traveller for School Trip Pune", "Group transportation support for educational tours, excursions, and student travel programs."],
["Tempo Traveller for Outstation Tour Pune", "Dedicated vehicle arrangement for multi-day tours and extended journeys from Pune."]
],
whychoose: [
{
WhyChooseheading: "Comfortable Group Transportation",
WhyChoosedescription: "Traveling together becomes easier when an entire group can use one suitable Tempo Traveller instead of coordinating several separate cars. Ruturaj Enterprises focuses on practical seating, comfortable interiors, luggage accommodation, and a journey arrangement that helps passengers remain together throughout the planned route."
},
{
WhyChooseheading: "Vehicle Options for Different Groups",
WhyChoosedescription: "Different trips require different levels of seating capacity and comfort, so vehicle selection can be planned around the size and purpose of the group. Options can be considered for family holidays, corporate travel, weddings, school excursions, picnics, sightseeing programs, and longer tourist tours."
},
{
WhyChooseheading: "Suitable for Short and Long Trips",
WhyChoosedescription: "From one-day excursions around nearby destinations to multi-day journeys across Maharashtra and neighboring states, Tempo Traveller rentals can be arranged for varied travel durations. This flexibility helps groups plan transportation around their itinerary rather than changing vehicles for different portions of the journey."
},
{
WhyChooseheading: "Convenient Luggage Space",
WhyChoosedescription: "Group travel often involves bags, personal belongings, event materials, or travel equipment, making luggage capacity an important consideration. A suitable Tempo Traveller provides a more organized transportation setup where passengers can travel together while accommodating the belongings required for their planned journey."
},
{
WhyChooseheading: "Useful for Events and Functions",
WhyChoosedescription: "Weddings, marriages, corporate events, school programs, and family functions often require coordinated movement between several locations. A dedicated Tempo Traveller can simplify these arrangements by supporting planned pickups, venue transfers, scheduled departures, and group transportation throughout the event itinerary."
},
{
WhyChooseheading: "Planned Travel Around Your Itinerary",
WhyChoosedescription: "Group journeys become easier to manage when transportation is coordinated with the actual travel schedule. Rental planning can take into account pickup locations, destinations, sightseeing stops, overnight stays, return timings, and other route requirements so the vehicle arrangement fits the overall trip plan."
},
{
WhyChooseheading: "Practical Choice for Group Budgets",
WhyChoosedescription: "Hiring one suitable group vehicle can be a practical alternative to arranging multiple individual cars for the same journey. Depending on the group size and trip requirements, a Tempo Traveller can help simplify transportation planning while allowing passengers to share the journey and manage travel arrangements more efficiently."
},
{
WhyChooseheading: "Dedicated Support for Travel Requirements",
WhyChoosedescription: "Ruturaj Enterprises supports different types of group transportation requirements, including tourist tours, airport transfers, corporate movements, family holidays, school trips, picnics, weddings, and outstation journeys. The focus remains on matching the rental arrangement with the planned destination, passenger needs, schedule, and overall purpose of travel."
}
]
};










const faqData = [
{
question: "How can I arrange a Tempo Traveller Rental in Pune?",
answer: "A Tempo Traveller rental in Pune can be organized by sharing the pickup location, destination, travel date, number of travelers, journey duration, and planned route. Ruturaj Enterprises can coordinate suitable group transportation for family holidays, weekend trips, pilgrimages, corporate outings, weddings, sightseeing tours, and outstation journeys."
},
{
question: "What makes a Tempo Traveller useful for group travel?",
answer: "A Tempo Traveller allows a group to travel together in one dedicated vehicle instead of coordinating multiple cars. It can be a practical option for families, friends, corporate teams, and tour groups that need organized transportation for sightseeing, outstation travel, multi-day tours, events, or journeys involving several planned stops."
},
{
question: "Which seating options can be considered for Tempo Traveller rental in Pune?",
answer: "Tempo Traveller vehicles can be available in different seating configurations to suit varying group sizes. The appropriate option can be considered based on the number of passengers, luggage volume, travel distance, and trip duration, helping the group select a vehicle that fits its transportation requirements."
},
{
question: "Can I rent a Tempo Traveller in Pune for an outstation tour?",
answer: "Outstation Tempo Traveller rentals can be arranged from Pune for destinations across Maharashtra and other states. Groups can plan one-day excursions, weekend getaways, or longer tours with multiple sightseeing locations, meal breaks, rest stops, overnight stays, and return travel incorporated into the itinerary."
},
{
question: "Is Tempo Traveller rental available for family vacations?",
answer: "Families can use a rented Tempo Traveller for holidays and multi-destination tours where everyone prefers to travel together. The journey can be organized around the family's pickup point, sightseeing schedule, luggage requirements, planned breaks, accommodation locations, and return timing."
},
{
question: "Can a Tempo Traveller be rented for corporate outings in Pune?",
answer: "Corporate teams can arrange a Tempo Traveller for employee outings, conferences, team-building activities, business events, training programs, and company trips. Multiple pickup points, passenger numbers, destination details, event timings, and return schedules can be considered while preparing the transportation plan."
},
{
question: "Can I use a Tempo Traveller for a wedding in Pune?",
answer: "Wedding groups can arrange a Tempo Traveller to transport relatives and guests between residences, hotels, railway stations, airports, marriage halls, banquet venues, and reception locations. A dedicated vehicle can simplify guest movement while allowing transfers to be coordinated around ceremony and event timings."
},
{
question: "Is a Tempo Traveller suitable for pilgrimage tours from Pune?",
answer: "Pilgrimage groups can rent a Tempo Traveller for temple visits and religious tours covering one or several destinations. The itinerary can include darshan points, temple timings, meal breaks, rest stops, sightseeing locations, and overnight halts, allowing the group to remain together throughout the planned journey."
},
{
question: "What details are needed to book a Tempo Traveller in Pune?",
answer: "When requesting a rental, provide the pickup location, destination, travel date, passenger count, luggage requirements, number of travel days, intermediate stops, and preferred schedule. A detailed itinerary is particularly useful for multi-day journeys because it allows Ruturaj Enterprises to understand the complete transportation requirement."
},
{
question: "Why choose Ruturaj Enterprises for Tempo Traveller Rental Pune?",
answer: "Ruturaj Enterprises coordinates Tempo Traveller transportation for family tours, corporate outings, weddings, pilgrimages, sightseeing programs, weekend trips, and outstation journeys from Pune. Rental arrangements can be planned according to group size, route, luggage, travel duration, pickup requirements, planned stops, and the overall itinerary."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Kunal Wagh",
feedback:
"We rented a Tempo Traveller from Ruturaj Enterprises for a multi-day family tour from Pune. Traveling together in one vehicle made it much easier to follow our sightseeing plan and coordinate meal and rest stops. The arrangement was particularly convenient because we had several bags and multiple destinations on our itinerary.",
rating: 5
},
{
id: 2,
name: "Miss. Neha Mahajan",
feedback:
"Our friends' group used a Tempo Traveller for an outstation trip from Pune and found the group transportation convenient. Instead of arranging separate cars, everyone could travel together according to the same schedule. The shared vehicle also made it easier to manage our planned sightseeing and return journey.",
rating: 5
}
];






























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller Rental Pune",
  "image": "https://ruturajenterprises.com/assets/images/tempo-traveller-rental-pune.webp",
  "description":
    "Tempo Traveller Rental Pune for family holidays, group tours, corporate travel, weddings, outstation journeys, sightseeing, pilgrimages and special events. Ruturaj Enterprises provides Tempo Traveller rental, hire and booking services with AC, non-AC and luxury options for comfortable group transportation. Vehicles are suitable for weekend getaways, one-day trips, multi-day tours, airport transfers, wedding guest transportation, school and college excursions and long-distance travel from Pune to destinations across Maharashtra and other states, with experienced drivers and flexible rental plans.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/tempo-traveller-rental-pune"
  }
};






    return (
        <div>


<Helmet>
  <title>
    Tempo Traveller Rental Pune | Tempo Traveller Hire Pune | +91 9763381382
  </title>

  <meta
    name="description"
    content="Tempo Traveller Rental Pune for family trips, group travel, corporate events, weddings, outstation tours, sightseeing and airport transfers. Hire AC, non-AC and luxury Tempo Travellers from Ruturaj Enterprises."
  />

  <meta
    name="keywords"
    content="Tempo Traveller On Rent Pune, Tempo Traveller Hire Pune, Tempo Traveller Booking Pune, AC Tempo Traveller Rental Pune, Non AC Tempo Traveller Rental Pune, Luxury Tempo Traveller Rental Pune, Tempo Traveller for Outstation Pune, Tempo Traveller for Family Trip Pune, Tempo Traveller for Group Travel Pune, Tempo Traveller for Corporate Events Pune, Tempo Traveller for Wedding Pune, Tempo Traveller for School Trip Pune, Tempo Traveller for Picnic Pune, Tempo Traveller for Airport Pickup Pune, Affordable Tempo Traveller Rental Pune, Tempo Traveller Rental Pune, Tempo Traveller On Rent in Pune, Tempo Traveller Hire in Pune, Tempo Traveller Booking in Pune, Tempo Traveller Rental Service Pune, Tempo Traveller Hire Service Pune, Tempo Traveller Booking Service Pune, AC Tempo Traveller Pune, AC Tempo Traveller On Rent Pune, AC Tempo Traveller Hire Pune, AC Tempo Traveller Booking Pune, Non AC Tempo Traveller Pune, Non AC Tempo Traveller On Rent Pune, Non AC Tempo Traveller Hire Pune, Non AC Tempo Traveller Booking Pune, Luxury Tempo Traveller Pune, Luxury Tempo Traveller On Rent Pune, Luxury Tempo Traveller Hire Pune, Luxury Tempo Traveller Booking Pune, Tempo Traveller for Tourist Pune, Tourist Tempo Traveller Pune, Tourist Tempo Traveller Rental Pune, Tourist Tempo Traveller Hire Pune, Tempo Traveller for Outstation Pune, Outstation Tempo Traveller Pune, Outstation Tempo Traveller Rental Pune, Outstation Tempo Traveller Hire Pune, Outstation Tempo Traveller Booking Pune, One Way Tempo Traveller Pune, One Way Tempo Traveller Rental Pune, One Way Tempo Traveller Hire Pune, Round Trip Tempo Traveller Pune, Round Trip Tempo Traveller Rental Pune, Round Trip Tempo Traveller Hire Pune, Local Tempo Traveller Pune, Local Tempo Traveller Rental Pune, Local Tempo Traveller Hire Pune, Local Tempo Traveller Booking Pune, Family Tempo Traveller Pune, Family Tour Tempo Traveller Pune, Family Travel Tempo Traveller Pune, Group Tempo Traveller Pune, Group Tour Tempo Traveller Pune, Group Travel Tempo Traveller Pune, Corporate Tempo Traveller Pune, Corporate Tempo Traveller Rental Pune, Corporate Tempo Traveller Hire Pune, Corporate Tempo Traveller Booking Pune, Corporate Staff Transportation Tempo Traveller Pune, Corporate Event Tempo Traveller Pune, Event Tempo Traveller Rental Pune, Event Tempo Traveller Hire Pune, Event Tempo Traveller Booking Pune, Wedding Tempo Traveller Pune, Wedding Tempo Traveller Rental Pune, Wedding Tempo Traveller Hire Pune, Wedding Tempo Traveller Booking Pune, Wedding Guest Tempo Traveller Pune, Wedding Guest Transportation Tempo Traveller Pune, Marriage Tempo Traveller Pune, Marriage Tempo Traveller Rental Pune, Marriage Tempo Traveller Hire Pune, School Tempo Traveller Pune, School Trip Tempo Traveller Pune, School Tour Tempo Traveller Pune, College Trip Tempo Traveller Pune, College Tour Tempo Traveller Pune, Picnic Tempo Traveller Pune, Picnic Tempo Traveller Rental Pune, Picnic Tempo Traveller Hire Pune, Family Picnic Tempo Traveller Pune, Group Picnic Tempo Traveller Pune, Airport Tempo Traveller Pune, Airport Transfer Tempo Traveller Pune, Airport Pickup Tempo Traveller Pune, Airport Drop Tempo Traveller Pune, Sightseeing Tempo Traveller Pune, Sightseeing Tempo Traveller Rental Pune, Sightseeing Tempo Traveller Hire Pune, Pune City Tour Tempo Traveller Pune, Tempo Traveller for Maharashtra Tour Pune, Tempo Traveller for Weekend Trip Pune, Tempo Traveller for Holiday Trip Pune, Tempo Traveller for Temple Tour Pune, Pilgrimage Tempo Traveller Pune, Tempo Traveller for Tourist Pune, Tempo Traveller with Driver Pune, Tempo Traveller Rental with Driver Pune, Tempo Traveller Hire with Driver Pune, Tempo Traveller Booking with Driver Pune, Comfortable Tempo Traveller Pune, Premium Tempo Traveller Pune, Professional Tempo Traveller Rental Pune, Reliable Tempo Traveller Hire Pune, Tempo Traveller Transportation Pune, Group Transportation Tempo Traveller Pune, Tempo Traveller Service Pune, Tempo Traveller Rental Near Me Pune, Tempo Traveller Hire Near Me Pune, Ruturaj Enterprises Tempo Traveller Rental Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/91.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Tempotravellerrentalpune;